import { useState, useRef } from "react";
import { Keyboard, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import getConfig from "next/config";
import md5 from "md5";

import "swiper/css";
import "swiper/css/navigation";
import CarouselNavArrow from "@components/Icons/CarouselNavArrow";

const {
  publicRuntimeConfig: { settings },
} = getConfig();

const ReviewsImagesSlider = ({ reviewsWithImages, onImageSelect }) => {
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const nextArrowRef = useRef(null);
  const prevArrowRef = useRef(null);

  return (
    <div className="flex">
      {/* arrow-left will add display: none; if images are less than slides per view; adding any other display will overwrite */}
      <div ref={prevArrowRef}>
        <div
          className={`flex items-center h-full bg-[#F6F5F5] w-[25px] ${
            isBeginning
              ? "opacity-50 cursor-default"
              : "opacity-90 cursor-pointer"
          }`}
        >
          <CarouselNavArrow />
        </div>
      </div>

      <Swiper
        className="w-full overflow-hidden px-[4px]"
        modules={[Navigation, Keyboard]}
        loop={false}
        navigation={{
          nextEl: nextArrowRef.current,
          prevEl: prevArrowRef.current,
        }}
        keyboard={true}
        autoHeight={true}
        onSlideChange={({ isBeginning, isEnd }) => {
          setIsBeginning(isBeginning);
          setIsEnd(isEnd);
        }}
        slidesPerGroup={1}
        slidesPerView={2}
        spaceBetween={10}
        breakpoints={{
          250: {
            slidesPerGroup: 1,
            slidesPerView: 2,
            spaceBetween: 6,
          },
          320: {
            slidesPerGroup: 1,
            slidesPerView: 3,
            spaceBetween: 6,
          },
          480: {
            slidesPerGroup: 1,
            slidesPerView: 4,
            spaceBetween: 6,
          },
          640: {
            slidesPerGroup: 1,
            slidesPerView: 5,
            spaceBetween: 8,
          },
          768: {
            slidesPerGroup: 1,
            slidesPerView: 8,
            spaceBetween: 10,
          },
        }}
      >
        {reviewsWithImages.map((review) =>
          review.images.map((image, index) => (
            <SwiperSlide key={image}>
              <div className="">
                <img
                  className="object-cover aspect-square cursor-pointer h-[120px] rounded-[4px]"
                  key={image}
                  src={`${settings.cdn}/resize/reviews-files/${
                    review._id
                  }/${md5("120x0")}/${image}`}
                  alt={review._id}
                  onClick={() =>
                    onImageSelect({
                      reviewId: review._id,
                      imageIndex: index,
                    })
                  }
                />
              </div>
            </SwiperSlide>
          ))
        )}
      </Swiper>

      {/* arrow-right will add display: none; if images are less than slides per view; adding any other display will overwrite */}
      <div ref={nextArrowRef}>
        <div
          className={`flex items-center h-full bg-[#F6F5F5] w-[25px] ${
            isEnd ? "opacity-50 cursor-default" : "opacity-90 cursor-pointer"
          }`}
        >
          <CarouselNavArrow direction="right" />
        </div>
      </div>
    </div>
  );
};

export default ReviewsImagesSlider;
